{
  "title": "Edit Team",
  "nameLabel": "Team name",
  "save": "Save",
  "saving": "Saving..."
}
